import { Chapter, Counter, Reveal } from "@/components/motion";
import { STATS } from "@/data/site";

export default function Stats() {
  return (
    <section className="relative overflow-hidden bg-navy py-24 lg:py-28" data-testid="stats-section">
      <div className="absolute inset-0 bg-blueprint-dark opacity-30" />
      <div className="relative z-10 mx-auto max-w-7xl px-6">
        <Chapter index="02" label="Formcore at a Glance" dark />
        <div className="mt-16 grid gap-y-12 sm:grid-cols-2 lg:grid-cols-5 lg:divide-x lg:divide-white/10">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.08} className="lg:px-8 lg:first:pl-0">
              <p className="font-heading font-extrabold tracking-tight text-gold">
                {s.numeric ? (
                  <Counter to={s.value} suffix={s.suffix} className="text-5xl lg:text-[3.4rem]" />
                ) : (
                  <span className="text-2xl leading-tight lg:text-[1.7rem]">{s.value}</span>
                )}
              </p>
              <p className="mt-4 text-[11px] font-semibold uppercase tracking-[0.22em] leading-relaxed text-white/50">
                {s.label}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
